import ReadonlyIcon from "components/layouts/navbar/ReadonlyIcon";
import endpoints from "config/endpoints";
import paths from "config/routePaths";
import isEmpty from "lodash/isEmpty";
import Authorization from "policies/Authorization";
import { customWorkOrderFieldsMenuItem } from "./customWorkOrderFieldsMenuItem";

export function linksMenu({ policy }) {
  return [
    { href: "/", name: "Production Scheduling" },
    { href: paths.laborSummary, name: "Labor" },
    policy.canImport(Authorization.EntityTypes.WorkOrder) && { href: paths.manageData, name: "Manage data" },
    !policy.canUpdate(Authorization.EntityTypes.WorkBlock) && { name: "READ-ONLY", render: ReadonlyIcon },
  ].filter(Boolean);
}

export function settingsMenu({ applicationContext, policy }) {
  const menu = {
    items: [],
    name: "Settings",
  };

  if (policy.canUpdate(Authorization.EntityTypes.Shift)) {
    menu.items.push({ href: paths.shifts, name: "Shifts" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.Line)) {
    menu.items.push({ href: paths.lines, name: "Lines" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.PlannedBreak)) {
    menu.items.push({ href: paths.plannedBreaks, name: "Planned breaks" });
  }

  if (availabilitySubmenu(policy).length) {
    menu.items.push({ items: availabilitySubmenu(policy), name: "Availability" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.CustomWorkOrderField)) {
    menu.items.push(customWorkOrderFieldsMenuItem({ applicationContext }));
  }

  if (policy.canUpdate(Authorization.EntityTypes.DowntimeReason)) {
    menu.items.push({ href: paths.downtimeReasons, name: "Downtime reasons" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.TeardownTime)) {
    menu.items.push({ href: paths.teardownTimes, name: "Teardown times" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.CustomerSettings)) {
    menu.items.push({ href: paths.customerSettings, name: "Layout" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.Site)) {
    menu.items.push({ href: paths.siteEdit(applicationContext.site.id), name: "Edit current site" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.Company)) {
    menu.items.push({ href: paths.companyIndex, name: "Companies" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.Site)) {
    menu.items.push({ href: paths.siteIndex, name: "Sites" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.User)) {
    menu.items.push({ href: paths.userIndex, name: "Users" });
  }

  if (policy.canShow(Authorization.EntityTypes.UsageData)) {
    menu.items.push({ href: paths.adminDashboard, name: "Admin dashboard" });
  }

  return isEmpty(menu.items) ? null : menu;
}

export function authenticationMenu({ applicationContext: { user } }) {
  if (!user?.email) return { href: endpoints.login, name: "Login" };

  const items = [
    { href: paths.preferences, name: "Preferences" },
    { href: endpoints.logout, name: "Logout" },
  ];

  return { items, name: user.email };
}

function availabilitySubmenu(policy) {
  const result = [];

  if (policy.canUpdate(Authorization.EntityTypes.DefaultAvailability)) {
    result.push({ href: paths.defaultAvailability, name: "Default availability" });
  }

  if (policy.canUpdate(Authorization.EntityTypes.AvailabilityOverride)) {
    result.push({ href: paths.availabilityOverrides, name: "Availability overrides" });
  }

  return result;
}
